import React, { useRef } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { UploadFile as UploadFileIcon } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { AUDIT_PLAN_ALLOWED_TYPES } from "../../utils/auditPlanFileUtils";

const AuditPlanTabHeader = ({
  fileCount = 0,
  isAuditorView = false,
  adding = false,
  onAddFile,
}) => {
  const theme = useTheme();
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const selected = Array.from(event.target.files || []);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    selected.forEach((f) => onAddFile?.(f));
  };

  const primaryButtonSx = {
    bgcolor: theme.customColors.button.primary,
    color: theme.customColors.button.text,
    fontWeight: 500,
    borderRadius: "8px",
    textTransform: "none",
    fontSize: "14px",
    px: 2,
    py: 1,
    whiteSpace: "nowrap",
    boxShadow: "0 3px 8px rgba(0,0,0,0.18)",
    "&:hover": {
      bgcolor: theme.palette._blue?.dark || theme.customColors.button.primary,
      boxShadow: "0 4px 12px rgba(25, 118, 210, 0.35)",
    },
    "&:disabled": {
      bgcolor: theme.customColors.background.light,
      color: theme.customColors.text.disabled,
      boxShadow: "none",
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        width: "100%",
      }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography variant="h5" sx={{ fontSize: "18px", fontWeight: "bold" }}>
          Audit Plan
        </Typography>
        {fileCount > 0 && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {fileCount} {fileCount === 1 ? "file" : "files"} uploaded
          </Typography>
        )}
      </Box>

      {!isAuditorView && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexShrink: 0 }}>
          <input
            type="file"
            accept={AUDIT_PLAN_ALLOWED_TYPES.join(",")}
            hidden
            multiple
            ref={fileInputRef}
            onChange={handleFileChange}
            disabled={adding}
          />
          <LoadingButton
            variant="contained"
            startIcon={<UploadFileIcon sx={{ fontSize: 16 }} />}
            loading={adding}
            disabled={adding}
            onClick={() => fileInputRef.current?.click()}
            sx={primaryButtonSx}
          >
            Add File
          </LoadingButton>
        </Box>
      )}
    </Box>
  );
};

export default AuditPlanTabHeader;
